import React, { Component } from "react";

import OffCampusApartments from "./OffCampusApartments";

import GuideMap from "../assets/offCampusGuide/map.JPG";
import locationSymbols from "../assets/offCampusGuide/location_symbol.JPG";

export default class OffCampusGuide extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container">
          <section>
            You can use this website to look at the apartments{" "}
            <a href="https://www.apartments.com/" target="_blank" rel="noreferrer">
              Apartments.com
            </a>
            <br />
            <br />
          </section>
          <section>
            <header className="section_head">MAP PLACES TO LOOK</header>
            <hr />
            <div className="text-center">
              <img src={locationSymbols} alt="locationSymbols" className="rounded img-thumbnail" />
              <img src={GuideMap} alt="Map" className="rounded img-thumbnail" />
            </div>
            <br />
            <br />
            <hr />
          </section>
          <section>
            <header className="section_head">House Info</header>
            <hr />
            <OffCampusApartments />
          </section>
        </div>
      </React.Fragment>
    );
  }
}
